export default __webpack_public_path__ + "static/media/books.a8118c09.png";